export const TIME_FREQUENCY = {
  DAYS: "24",
  WEEK: "168",
  MONTH: "730",
  YEAR: "8760",
};

export const TIME_FREQUENCY_LABELS = {
  [TIME_FREQUENCY.DAYS]: "dias",
  [TIME_FREQUENCY.WEEK]: "semanas",
  [TIME_FREQUENCY.MONTH]: "meses",
  [TIME_FREQUENCY.YEAR]: "anos",
};
